var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
import { LinkEntityButton } from './link-entity-button';
var cls = classNames('block-button-links');
export var BlockButtonLinksDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n\n    ", "\n  "], ["\n    margin-bottom: ", ";\n\n    ", "\n  "])), theme.UNIT(3), function (_a) {
    var _count = _a._count;
    return _count && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      flex-basis: ", "%;\n    "], ["\n      flex-basis: ", "%;\n    "])), 1 / _count * 100);
  }),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", ";\n    &:last-child {\n      margin-right: 0;\n    }\n  "], ["\n    margin-right: ", ";\n    &:last-child {\n      margin-right: 0;\n    }\n  "])), theme.UNIT(3))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: styled(LinkEntityButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var BlockButtonLinks = function BlockButtonLinks(props) {
  var className = props.className,
      entity = props.entity,
      rest = __rest(props, ["className", "entity"]);

  var _a = entity.links,
      links = _a === void 0 ? [] : _a;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, links.map(function (link) {
    return React.createElement(My.Link, __assign({
      _count: links.length,
      variant: 'slim'
    }, rest, {
      key: link.id,
      entity: link
    }));
  }));
};
BlockButtonLinks.defaultProps = BlockButtonLinksDefaultProps;
BlockButtonLinks.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;